module.exports = __webpack_public_path__ + "media/Danfoss DDP v8.99f45962.mp4";